import { ContentStyle } from './types/ContentStyle';

type RouteType = {
  prefix: string;
  path: string;
  contentStyle: ContentStyle; // Veeqo styling or Seller Central (KATAL) Styling
  vqHost: 'SeCe' | 'standalone'; // Seller Central or Standalone
  entryType: 'landing' | 'lwsc' | 'insc'; // Landing (legacy) | Login With Seller Central (LWSC) | In Seller Central (INSC)
};

// Legacy 1-click signup routes
const LEGACY_ROUTES: RouteType[] = [
  // Production route with Veeqo branding
  {
    prefix: '/vq/sc/',
    path: 'landing',
    vqHost: 'SeCe',
    contentStyle: ContentStyle.VEEQO,
    entryType: 'landing',
  },
  // Local testing with Veeqo branding
  {
    prefix: '/',
    path: 'landing',
    vqHost: 'standalone',
    contentStyle: ContentStyle.VEEQO,
    entryType: 'landing',
  },
  // Local testing - Basic setup flow
  { prefix: '/', path: 'setup', vqHost: 'standalone', contentStyle: ContentStyle.VEEQO, entryType: 'landing' },
];

// LWSC Flow - Login With Seller Central (redirects to standalone Veeqo at app.veeqo.com)
const LWSC_ROUTES: RouteType[] = [
  {
    prefix: '/vq/sc/lwsc/',
    path: 'setup',
    vqHost: 'SeCe',
    contentStyle: ContentStyle.VEEQO,
    entryType: 'lwsc',
  },
];

// INSC Flow - In Seller Central (sets up user but keeps them within Seller Central)
const INSC_ROUTES: RouteType[] = [
  {
    prefix: '/vq/sc/insc/',
    path: 'setup',
    vqHost: 'SeCe',
    contentStyle: ContentStyle.SELLER_CENTRAL,
    entryType: 'insc',
  },
];

export const VQ_SC_ROUTE_LIST: RouteType[] = [...LEGACY_ROUTES, ...LWSC_ROUTES, ...INSC_ROUTES];
